import script from "./CreateUpdateDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateDashboard.vue?vue&type=style&index=0&id=7401403c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7401403c"]])

export default __exports__